import styled from "styled-components";
import {Checkbox, Radio, Modal, Form, Input} from "antd";

export const StyledModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 10px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
        overflow: hidden;
    }

    .ant-modal-header {
        background: #cf1322;
        border-bottom: none;
        padding: 20px 24px;
        border-radius: 10px 10px 0 0;

        .ant-modal-title {
            color: #fff;
            font-weight: 600;
            font-size: 18px;
            margin: 0;
        }
    }

    .ant-modal-close {
        top: 16px;
        right: 16px;

        .ant-modal-close-x {
            color: #fff !important;
            font-size: 16px;
            width: 32px;
            height: 32px;
            line-height: 32px;
            transition: all 0.3s ease;
            border-radius: 50%;

            &:hover {
                background-color: rgba(255, 255, 255, 0.2);
            }
        }
    }

    .ant-modal-body {
        padding: 24px;
        background: #fff;
    }

    .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 16px 24px;
        background: #fff;
        border-radius: 0 0 10px 10px;

        .ant-btn {
            height: 40px;
            border-radius: 6px;
            font-weight: 500;
            transition: all 0.3s ease;
        }

        .ant-btn-primary {
            background: #cf1322;
            border-color: #cf1322;
            color: #fff;

            &:hover:not(:disabled) {
                background: #cf1322;
                border-color: #cf1322;
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(#cf1322, 0.3);
            }

            &:disabled {
                background: #f5f5f5;
                border-color: #d9d9d9;
                color: #bfbfbf;
            }
        }

        .ant-btn-default {
            border-color: #d9d9d9;
            color: #666;

            &:hover {
                border-color: rgb(255, 90, 90);
                color: rgb(255, 90, 90);
            }
        }
    }
`;

export const StyledForm = styled(Form)`
    .ant-form-item-label > label {
        font-weight: 500;
        color: #333;
        font-size: 14px;
    }
`;

export const StyledInput = styled(Input)`
    height: 44px;
    border-radius: 6px;
    font-size: 16px;
    transition: all 0.3s ease;

    &:focus,
    &:hover {
        box-shadow: 0 0 0 2px rgba(255, 90, 90, 0.1);
    }
`;

export const RadioContainer = styled.div`
    margin: auto;
`;

export const RadioList = styled(Radio)`
    display: flex;
    align-items: center;
    height: 40px;
    margin-bottom: 8px;
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.3s ease;
    border: 1px solid #e8e8e8;

    &:hover {
        background-color: #f8f9fa;
        border-color: #cf1322;
    }

    &.ant-radio-wrapper-checked {
        background-color: rgba(#cf1322, 0.1);
        border-color: #cf1322;
    }

    .ant-radio {
        margin-right: 12px;
    }

    .ant-radio-checked .ant-radio-inner {
        border-color: #cf1322;
        background-color: #cf1322;
    }

    .ant-radio-inner::after {
        background-color: #000;
    }
`;

export const BottomCheckbox = styled(Checkbox)`
    margin-top: 20px;
    margin-left: 15px;
    margin-right: 10px;
`;
